import { useEffect, useState } from 'react'
import { useOptionalAuth } from '../context/useAuth'

/**
 * useIsSystemAdmin (SR8)
 *
 * Reads user?.getIdTokenResult(false) (no forced refresh)
 * once per uid from useOptionalAuth() and returns claims.systemAdmin === true.
 * Returns false while loading and when signed out.
 */
export function useIsSystemAdmin(): boolean {
  const { user } = useOptionalAuth()
  const currentUid = user?.uid
  const [adminUid, setAdminUid] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    if (!user || typeof user.getIdTokenResult !== 'function') {
      return
    }

    user
      .getIdTokenResult(false)
      .then((tokenResult) => {
        if (cancelled) return
        if (tokenResult?.claims?.systemAdmin === true) {
          setAdminUid(user.uid)
        } else {
          setAdminUid(null)
        }
      })
      .catch(() => {
        if (cancelled) return
        setAdminUid(null)
      })

    return () => {
      cancelled = true
    }
  }, [user, currentUid])

  return Boolean(currentUid && adminUid === currentUid)
}
